import OrderDetailContent, { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import Container from '@repo/ui/src/primitives/Container';
import React from 'react';

const OrderDetail = (props: OrderDetailProps) => (
  <Container maxWidth="4xl">
    <OrderDetailContent {...props} trackOrderDetail />
  </Container>
);

export default OrderDetail;
